import React from 'react';
import './HeroSection.css';
import bertolinLogo from '../logo/bertolinsolucoes-redondo.png'; // Importa a imagem da logo

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Adiciona a imagem da logo aqui */}
        <img src={bertolinLogo} alt="Bertolin Soluções Logo" className="hero-logo fade-in" style={{ animationDelay: '0s' }} />

        <h1 className="fade-in" style={{ animationDelay: '0.2s' }}>Soluções Criativas em Impressão 3D e Desenvolvimento de Software</h1>
        <p className="fade-in" style={{ animationDelay: '0.5s' }}>Transformamos suas ideias em realidade, desde objetos físicos impressos em 3D até experiências digitais com sites e aplicativos Android sob medida.</p>
      </div>
    </section>
  );
}

export default HeroSection;